<template>
    <router-view v-slot="{ Component }">
        <component :is="Component" :show-error="showError" />
    </router-view>
</template>

<script lang="ts" setup>
import { handleError } from '@zyno-io/vue-foundation';

import { useStore } from '@/store';

const rootStore = useStore();

function showError() {
    handleError(new Error('ZynoWorkstation Startup Error'));
    rootStore.globalError = `Something's not right. Please check your Internet connection and try again. If the issue persists, contact support@zyno.app.`;
}
</script>
